import React from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';

import { useDispatch } from 'react-redux';
import * as employeeApi from '../../../lib/api/employee';
import { listNP, listResult } from '../../../modules/empModule/empHr';
import NpForm from '../../../components/employeemng/np/NpForm';
import ResultForm from '../../../components/employeemng/result/ResultForm';



const ResultFormContainer = ({ employee }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const initialValues = {
    attrVal1: '',
    attrVal2: '',
    attrVal3: '',
  };

  const validationSchema = yup.object({
    attrVal1: yup.string('').required('평가년도를 입력하세요'),
    attrVal2: yup.string().required('종류를 입력하세용'),
    attrVal3: yup.string().nullable(''),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);

      let dataToSubmit = {
        usrUuid: employee.usrUuid,
        infoTyp: 'RESULT',
        attrVal1: values.attrVal1,
        attrVal2: values.attrVal2,
        attrVal3: values.attrVal3,
      };

      //console.log(JSON.stringify(dataToSubmit),'dataToSubmit');

      try {
        const response = await employeeApi.addResumeByEmp(dataToSubmit);
        if (response.data) {
          dispatch(
            listResult({
              id: employee.usrUuid,
              infoTyp: 'RESULT',
            }),
          );
        }
      } catch (err) {
        let message =
          typeof err.response !== 'undefined'
            ? err.response.data.message
            : err.message;
        enqueueSnackbar(message, {
          variant: 'error',
        });
      }

      formik.resetForm();
      setSubmitting(false);
    },
  });

  return <ResultForm formik={formik} />;
};

export default ResultFormContainer;
